import { render, staticRenderFns } from "./CollectionHover.vue?vue&type=template&id=96875f96&scoped=true&lang=pug"
import script from "./CollectionHover.vue?vue&type=script&lang=js"
export * from "./CollectionHover.vue?vue&type=script&lang=js"
import style0 from "./CollectionHover.vue?vue&type=style&index=0&id=96875f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96875f96",
  null
  
)

export default component.exports